module.exports = __webpack_public_path__ + "img/sinBarreras22.c6cf6a10.jpg";